import { WithSubpages } from '../../subpages';
import { walletSubpages } from '../../subpages/dictionary';
import { MAIN_PAGE_PATH } from './paths';
import { PAGE_TITLE } from '../../consts';

const Wallet = () => <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.WALLET} items={walletSubpages} />;
export default Wallet;
